'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var ShareIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M15 10.98v5c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1v-12c0-0.55 0.45-1 1-1h5"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="11" y2="0.98"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="17" y2="6.98"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="17" y1="0.98" x2="7.92" y2="10.06"/>';
    case 'medium':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M27 19.86v9.29C27 30.17 26.17 31 25.14 31H2.86C1.83 31 1 30.17 1 29.14V6.86C1 5.83 1.83 5 2.86 5h9.29"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="19.75" y2="1"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="31" y2="12.25"/><line stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="31" y1="1" x2="13.98" y2="18.02"/>';
    case 'large':
      return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M39.5 30.314v13.571c0 1.499-1.215 2.714-2.714 2.714H4.214c-1.499 0-2.714-1.215-2.714-2.714V11.314C1.5 9.815 2.715 8.6 4.214 8.6h13.571"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="29.625" y2="1.5"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="46.5" y2="18.375"/><line stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="46.5" y1="1.5" x2="20.969" y2="27.031"/>';
    }
  }
});

module.exports = ShareIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Share.jsx
 **/